

window.addEventListener('load', function() {  
function myFunctionName() {
  function calculateTotalUnits() {
    var cartItems = document.querySelectorAll('.rebuy-cart__flyout-items li.product-mini-deodorant-sticks');
    var totalUnits = 0;

    for (var i = 0; i < cartItems.length; i++) {
      var titleElement = cartItems[i].querySelector('.rebuy-cart__flyout-item-product-title');
      var quantityElement = cartItems[i].querySelector('.rebuy-cart__flyout-item-quantity-widget-label');

      var title = titleElement.textContent.trim();
      var quantity = parseInt(quantityElement.textContent.replace(/\D/g, ''), 10);

      if (!isNaN(quantity) && title === 'Mini Deodorant Sticks') {
        totalUnits += quantity;
      }
    }

    for (var i = 0; i < cartItems.length; i++) {
      var titleElement = cartItems[i].querySelector('.rebuy-cart__flyout-item-product-title');
      var title = titleElement.textContent.trim();

      if (title === 'Mini Deodorant Sticks') {
        var minimumText = cartItems[i].querySelector('.minimum-text');
        var brElement = cartItems[i].querySelector('.minimum-text-br');

        if (totalUnits < 3) {
          if (!minimumText) {
            minimumText = document.createElement('span');
            minimumText.textContent = '(Minimum of 3 Mini Sticks Per Order)';
            minimumText.className = 'minimum-text';
            minimumText.style.color = 'red';
            minimumText.style.fontSize = '13px';
            titleElement.after(minimumText);
          }

          if (!brElement) {
            brElement = document.createElement('br');
            brElement.className = 'minimum-text-br';
            minimumText.after(brElement);
          }
        } else {
          if (minimumText && brElement) {
            minimumText.remove();
            brElement.remove();
          }
        }
      }
    }

    return totalUnits;
  }

  function updateTotalUnits() {
    var totalUnitsFound = calculateTotalUnits();
    console.log('Total Units:', totalUnitsFound);
  }

  var cartObserver = new MutationObserver(function(mutations) {
    updateTotalUnits();
  });

  var cartConfig = { attributes: true, childList: true, characterData: true, subtree: true };
  var target = document.querySelector('.rebuy-cart__flyout-items');

  cartObserver.observe(target, cartConfig);

  updateTotalUnits();

  let targetNode = document.getElementById('rebuy-cart');
  let dialogConfig = { attributes: true, childList: false, subtree: false };
  let callback = function(mutationsList, dialogObserver) {
    for (let mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
        if (targetNode.getAttribute('aria-hidden') === 'false') {
          calculateTotalUnits();
          console.log('Cart is now visible');
        }
      }
    }
  };

  let dialogObserver = new MutationObserver(callback);
  dialogObserver.observe(targetNode, dialogConfig);

  var selectors = [
    '.rebuy-cart__flyout-item-remove',
    '.rebuy-cart__flyout-item-quantity-widget-button',
  ];

  selectors.forEach(function(selector) {
    document.body.addEventListener('click', function(e) {
      if (e.target.matches(selector)) {
        updateTotalUnits();
      }
    });
  });
}




  
  
     function addDataCountToVariantBoxes() {
        $('li.blank_variant_box').each(function(i, obj) {
            $(this).attr('data-count', i + 1);
        });
    }
    addDataCountToVariantBoxes();
function checkButtonStatus() {
  var boxes_size = $('.blank_variant_box').length;
  var selected_boxes_size = $('.itemadded').length;
  var remaining = 3 - selected_boxes_size; 
  var bundleBox = document.querySelector('.bundlebuybox');
 
if (selected_boxes_size >= 1) { 
bundleBox.classList.add('fixedbottom');
} else {
bundleBox.classList.remove('fixedbottom'); 
}
  
  if (selected_boxes_size >= 3) {
    $('button.custom-bundle-submit').removeAttr('disabled');
    var totalPrice = 0;
    $('.blank_variant_box.itemadded').each(function() {
      var p = $(this).data('price');
      p = parseFloat(p);
      totalPrice = totalPrice + p;
    });
    totalPrice = totalPrice / 100;
    $('.custom-bundle-submit span').text('Add to cart - $'+parseFloat(totalPrice));
  } else {
    var label;
    if (remaining == 1) {
      label = 'Select 1 more product';
    } else {
      label = 'Select '+remaining+' more products';
    }
    if (selected_boxes_size == 0) {
      label = 'Pick 3 products';
    }
    $('button.custom-bundle-submit span').text(label);
    $('button.custom-bundle-submit').attr('disabled', 'disabled');
  }
}


  
    var selectors = {
      drawer: '#CartDrawer',
      form: '#CartDrawerForm'
    };
  
    var form = document.querySelector(selectors.form);
    var drawer = new theme.Drawers('CartDrawer', 'cart');


    function init() {      
      var form = document.querySelector(selectors.form);
      var drawer = new theme.Drawers('CartDrawer', 'cart');
      var cartForm = new theme.CartForm(form);
      cartForm.buildCart();

      document.addEventListener('ajaxProduct:added', function(evt) {
        document.body.classList.add('cart-has-items');
        cartForm.buildCart();
        open();
      }.bind(this));

      // Dev-friendly way to open cart
      document.addEventListener('cart:open', this.open.bind(this));
      document.addEventListener('cart:close', this.close.bind(this));
    };

    function open() {
      drawer.open();
    };

    function close() {
      drawer.close();
    }
  
    $('button.add_variant_box').click(function() {
      var img = $(this).parents('.variant_box').find('img').attr('src');
      var id = $(this).data('id');
      var price = $(this).data('price');
      var appendeditem = false;
      var html = '<img src="'+img+'" class="data-selected-id" data-selected-id="'+id+'" />'
      $('.blank_variant_box').each(function() {
        if (!appendeditem) {
          if (!$(this).hasClass('itemadded')) {
            $(this).append(html);
            $(this).addClass('itemadded');
            $(this).attr('data-price', price);
            appendeditem = true;
          }
        }
      });
      checkButtonStatus();
    });

    $(document).on('click', 'span.emptybox', function() {
      $(this).parents('.blank_variant_box').find('.data-selected-id').remove();
      $(this).parents('.blank_variant_box').removeClass('itemadded');
      $(this).parents('.blank_variant_box').removeAttr('data-price');

      var arrangedBoxes = '';
      var bottomBoxes = '';
      $('.blank_variant_box').each(function() {
        if ($(this).hasClass('itemadded')) {
          var price = $(this).attr('data-price');
          arrangedBoxes += '<li class="blank_variant_box itemadded" data-price="'+price+'">'+$(this).html()+'</li>';
        } else {
          bottomBoxes += '<li class="blank_variant_box">'+$(this).html()+'</li>';
        }
      });
      $('.blank_variant_box_wrapper').html(arrangedBoxes+bottomBoxes);
      checkButtonStatus();
      addDataCountToVariantBoxes();
    });
  
  $('button.custom-bundle-submit').on('click', function(){
    var productItems = [];    
    var productItemsFinal = [];
    var html = '';
    $(this).addClass('btn--loading');
    $('.itemadded .data-selected-id').each(function(i, v) {
      var id = $(this).attr('data-selected-id');
      productItems.push(id);
    });

    productItems.sort();

    var current = null;
    var cnt = 0;
    for (var i = 0; i < productItems.length; i++) {
        if (productItems[i] != current) {
            if (cnt > 0) {
                var item = {
                  id: current,
                  quantity: cnt
                }
                productItemsFinal.push(item);
            }
            current = productItems[i];
            cnt = 1;
        } else {
            cnt++;
        }
    }
    if (cnt > 0) {
        var item = {
          id: current,
          quantity: cnt
        }
        productItemsFinal.push(item);
    }

    var data = {
      items: productItemsFinal
    }; 

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      success: () => {
        $('button.custom-bundle-submit').removeClass('btn--loading');
        init();
        $('.js-drawer-open-cart').trigger('click');

        $('.bundlebuybox').removeClass('fixedbottom');
        $('.blank_variant_box').removeClass('itemadded');
        $('.blank_variant_box img').remove();

        var boxes_size = $('.blank_variant_box').length;
        $('button.custom-bundle-submit span').text('Added');
        
        setTimeout(function() {
          $('button.custom-bundle-submit').attr('disabled', 'disabled');
          $('button.custom-bundle-submit span').text('Select '+boxes_size+' products');
        }, 1000);
         setTimeout(function() {
         myFunctionName();
        }, 2000);
         drawer.open();
      },
      error: function(xhr, status, error) {
        console.log(xhr);
        $('button.custom-bundle-submit').removeClass('btn--loading');
      },
      dataType: 'json'
    });
  });
});
